<template>
  <div class="app-container member-list">
    <basic-container class="member-list-container">
      <avue-crud ref="crud"
                 :option="tableOption"
                 :data="list"
                 :table-loading="listLoading"
                 @refresh-change="refreshChange"
                 @sort-change="handleSortChange">
        <template slot="menuLeft">
          <el-button 
                     v-if="permissions.analysis_post_summary_export"
                     class="filter-item"
                     @click="handleExportAnalysisSummaryData()"
                     size="small"
                     type="primary"
                     :loading="exportAnalysisSummaryDataLoading"
                     icon="el-icon-download">{{exportAnalysisSummaryDataName}}
          </el-button>
        </template>
      </avue-crud>
      <el-button
        class="add-custom-time-btn"
        @click="showCustomDateRangeField()"
        icon="el-icon-plus">自定义时间段
      </el-button>
      <div class="trend-summary">
        <div class="trend-summary-description">统计走势图</div>
        <div class="search-field">
          <el-date-picker
            class="search-field-daterange"
            v-model="searchedDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="selectDate"
            :clearable=false
            size="small">
          </el-date-picker>
          <el-select class="search-field-datetype" placeholder="状态" @change="drawChart" v-model="dateType" size="medium">
            <el-option
              v-for="item in dateTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-button 
                     v-if="permissions.analysis_post_trend_export"
                     class="search-field-btn"
                     @click="handleExportAnalysisSummaryTrendData()"
                     size="small"
                     type="primary"
                     :loading="exportAnalysisSummaryTrendDataLoading"
                     icon="el-icon-download">{{exportAnalysisSummaryTrendDataName}}
          </el-button>
        </div>
        <div ref="summaryChart" class="search-summary"></div>
      </div>
    </basic-container>
    <el-dialog title="自定义时间段" :visible.sync="ShowCustomerFiledDialog" width="500px" class="handle-dialog">
      <div class="handle-dialog-item">
        <el-date-picker
          class="handle-dialog-item-date"
          v-model="customerSearchTime"
          type="daterange"
          value-format="yyyy-MM-dd"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          size="small">
        </el-date-picker>
      </div>
      <div class="handle-dialog-footer">
        <el-button type="primary" class="handle-dialog-footer-save" @click="confirmCusromerSearch">确定</el-button>
        <el-button class="handle-dialog-footer-cancel" @click="ShowCustomerFiledDialog = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {fetchAnalysisSummary, getSummaryDataByPeriod, exportAnalysisSummaryData, exportAnalysisSummaryTrendData, getPostStatisticsSummaryTrend} from '@/api/analysis/postAnalysis'
  import { exporting } from '@/util/exportUtil'
  import {tableOption} from '@/const/crud/analysis/postAnalysis'
  import * as echarts from 'echarts';
  import { formatDate } from '@/util/date';
  import {mapGetters} from "vuex";

  export default {
    name: "table_member",
    data() {
      return {
        ShowCustomerFiledDialog:false,
        exportAnalysisSummaryDataLoading: false,
        exportAnalysisSummaryDataName: "导出",
        exportAnalysisSummaryTrendDataLoading: false,
        exportAnalysisSummaryTrendDataName: "导出",
        customerSearchTime: [],
        list: [],
        tableOption: tableOption,
        listLoading: false,
        customerDateRangeFileds: [],
        expireTimeOption: {
          disabledDate(date) {
            return date.getTime() > Date.now();
          }
        },
        searchedDateRange: [],
        lessDayRanges:[
          {
            label: '按天',
            value: 'day'
          },
          {
            label: '按周',
            value: 'week'
          }
        ],
        moreDayRanges: [
          {
            label: '按周',
            value: 'week'
          },
          {
            label: '按月',
            value: 'month'
          }
        ],
        dateTypes: [],
        dateType: ''
      };
    },
    computed: {
      ...mapGetters(['permissions']),
    },
    created() {
      this.init()
      this.getAnalysisSummary()
    },
    mounted() {
      this.drawChart()
    },
    methods: {
      init() {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        this.searchedDateRange.push(formatDate('YYYY-mm-dd', start))
        this.searchedDateRange.push(formatDate('YYYY-mm-dd', end))
        this.dateTypes = this.lessDayRanges
        this.dateType = 'day'
      },
      selectDate(e) {
        var nDays = this.daysBetween(this.searchedDateRange[0], this.searchedDateRange[1]);
        if(nDays > 15) {
          this.dateTypes = this.moreDayRanges
        } else {
          this.dateTypes = this.lessDayRanges
        }
        if (this.dateType != 'week') {
          this.dateType = this.dateTypes[0].value
        }
        this.drawChart()
      },
      daysBetween(sDate1,sDate2){
        //Date.parse() 解析一个日期时间字符串，并返回1970/1/1 午夜距离该日期时间的毫秒数
        var time1 = Date.parse(new Date(sDate1));
        var time2 = Date.parse(new Date(sDate2));
        var nDays = Math.abs(parseInt((time2 - time1)/1000/3600/24)) + 1;
        return nDays;
      },
      getAnalysisSummary() {
        this.listLoading = true
        fetchAnalysisSummary().then(response => {
          this.list = response.data.data
          this.listLoading = false
        });
      },
      showCustomDateRangeField() {
        this.customerSearchTime = []
        this.ShowCustomerFiledDialog = true
      },
      confirmCusromerSearch() {
        if(this.customerSearchTime.length == 0) {
          this.$message({
              message: '请选择查询时间段',
              type: 'warning',
              showClose: true,
            });
          return
        }
        this.ShowCustomerFiledDialog = false

        let params = {}
        params.fromDate = this.customerSearchTime[0]
        params.toDate = this.customerSearchTime[1]
        this.customerDateRangeFileds.push(params)
        getSummaryDataByPeriod(params).then(response => {
          if (response.status === 200 && response.data && response.data.data) {
            this.list.push(response.data.data)
          }
        })
      },
      handleExportAnalysisSummaryData() {
        exportAnalysisSummaryData(this.customerDateRangeFileds).then(response => {
          if (response.status === 200 && response.data && response.data.data) {
            this.exportAnalysisSummaryDataLoading = true
            this.exportAnalysisSummaryDataName = "导出中..."
            exporting(response.data.data, this.exportAnalysisSummaryDataCallback)
          } else {
            this.$message({
              message: '信息导出失败',
              type: 'warning',
              showClose: true,
            });
          }
        });
      },
      exportAnalysisSummaryDataCallback(result) {
        this.exportAnalysisSummaryDataLoading = false
        this.exportAnalysisSummaryDataName = "导出"
        if (result) {
          this.$message({
            showClose: true,
            message: '导出完成',
            type: 'success'
            })
        }
      },      
      handleExportAnalysisSummaryTrendData() {
        let param = {}
        param.fromDate = this.searchedDateRange[0]
        param.toDate = this.searchedDateRange[1]
        param.type = this.dateType
        exportAnalysisSummaryTrendData(param).then(response => {
          if (response.status === 200 && response.data && response.data.data) {
            this.exportAnalysisSummaryTrendDataLoading = true
            this.exportAnalysisSummaryTrendDataName = "导出中..."
            exporting(response.data.data, this.exportAnalysisSummaryTrendDataCallback)
          } else {
            this.$message({
              message: '信息导出失败',
              type: 'warning',
              showClose: true,
            });
          }
        });
      },      
      exportAnalysisSummaryTrendDataCallback(result) {
        this.exportAnalysisSummaryTrendDataLoading = false
        this.exportAnalysisSummaryTrendDataName = "导出"
        if (result) {
          this.$message({
            showClose: true,
            message: '导出完成',
            type: 'success'
            })
        }
      },
      drawChart () {
        let param = {}
        param.fromDate = this.searchedDateRange[0]
        param.toDate = this.searchedDateRange[1]
        param.type = this.dateType

        getPostStatisticsSummaryTrend(param).then(response => {
          var myChart = echarts.init(this.$refs.summaryChart);
          let options = {
            color: ['#57C6CD', '#C490BF', '#C1232B','#B5C334','#FCCE10','#E87C25','#27727B'],
            tooltip: {
              show: true,
              trigger: 'axis'
            },
            textStyle: {
              color: '#606266'
            },
            legend:{
              y: 'bottom',
              x: 'center'
            },
            xAxis: {
              data: response.data.data.dates,
            },
            grid: {
              // x: 65 支持显示最长7位数的宽度
              // x 不设置会给表格左边大量留白
              x: 65,
              y: 30,
              x2: 35,
              y2: 65,
              borderWidth: 0
            },
            yAxis: {},
            series: [
              {
                name: "帖子",
                type: "line",
                symbol: 'circle',
                data: response.data.data.totalPostCounts,
              },
              {
                name: "评论",
                type: "line",
                symbol: 'circle',
                data: response.data.data.totalCommentCounts,
              },
              {
                name: "点赞",
                type: "line",
                symbol: 'circle',
                data: response.data.data.totalLikeCounts,
              },
              {
                name: "收藏",
                type: "line",
                symbol: 'circle',
                data: response.data.data.totalFavoriteCounts,
              },
              {
                name: "浏览量",
                type: "line",
                symbol: 'circle',
                data: response.data.data.totalViewCounts,
              },
              // {
              //   name: "UV",
              //   type: "line",
              //   symbol: 'circle',
              //   data: response.data.data.totalUniqueViewCounts,
              // },
            ],
          }

          myChart.setOption(options);
        });
      },
      refreshChange () {
        this.listLoading = true;
        fetchAnalysisSummary().then(response => {
          if (response.status === 200 && response.data && response.data.data) {
            // 使用新数据顺序替换旧数据
            for (let index = 0; index < response.data.data.length; index++) {
              const newItem = response.data.data[index];
              const oldItem = this.list[index]
              oldItem.totalCommentCount = newItem.totalCommentCount;
              oldItem.totalFavoriteCount = newItem.totalFavoriteCount;
              oldItem.totalLikeCount = newItem.totalLikeCount;
              oldItem.totalPostCount = newItem.totalPostCount;
              oldItem.totalUniqueViewCount = newItem.totalUniqueViewCount;
              oldItem.totalViewCount = newItem.totalViewCount;
            }
          }
        }).finally(() => {
          this.listLoading = false;
        })
      }
    }
  };
</script>

<style lang="scss" scoped>
.add-custom-time-btn {
  color:#409EFF;
  background:0 0;
  padding-left:0;
  padding-right:0;
  padding-top:0;
  font-size: 14px;
  font-weight: 500;
  border-color:transparent
}
.handle-dialog {
  display: flex;
  flex-direction: column;
    &-item {
      width: 450px;
      display: flex;
      flex-direction: row;
      &-label {
        text-align: center;
        font-size: 14px;
        width: 110px;
        line-height: 36px;
        padding: 0 5px;
      }
      &-input {
        font-size: 14px;
        width: 300px;
        height: 36px;
      }
    }
    &-footer{
      display: flex;
      flex-direction: row;
      padding: 20px 0px;
      &-save {
        padding: 8px 12px;
        position: absolute;
        right: 90px;
      }
      &-cancel {
        padding: 8px 12px;
        position: absolute;
        right: 10px;
        margin-right: 10px;
      }
    }
    &-img {
      max-width: 500px;
    }
}
.trend-summary {
  width: 100%;
  border: 1px solid #ededed;
  box-shadow: 0 1px 3px rgba(205, 205, 205, .5);
  &-description {
    color: #999;
    background: #f5f5f5;
    padding: 10px 15px 8px;
    font-size: 14px
  }
}

.search-field{
  display: flex;
  padding-top: 20px;
  padding-left: 15px;
  flex-direction: row;
  &-daterange {
    width: 400px!important;
    height: 36px;
  }
  &-datetype {
    padding-left: 10px;
    width: 150px!important;
  }
  &-btn {
    margin-left: 10px;
    width: 80px!important;
  }
}

.search-summary {
  width: 100%;
  height: 400px;
}

/deep/ .el-dialog__body {
  padding: 10px 20px 24px;
}
</style>
